module.exports = __webpack_public_path__ + "static/media/googlehome-pod.32f10b97.png";